// The web side of the module contract: each module adds sidebar entries and pages to an area.
import type { ComponentType, LazyExoticComponent } from 'react'
import type { Area, PermissionRequirement } from '@briary/shared'
import type { IconName } from '../ui/icons'

export interface NavItem {
  label: string
  path: string
  icon: IconName
  /** Permission needed to see the link (admin area). */
  perm?: PermissionRequirement
  /** Shown greyed out as "coming" — the roadmap, visible. */
  soon?: boolean
}

export interface RouteDef {
  path: string
  component: LazyExoticComponent<ComponentType<{ params: Record<string, string> }>> | ComponentType<{ params: Record<string, string> }>
  perm?: PermissionRequirement
}

export interface WebModule {
  id: string
  area: Area
  /** Items are merged into the area's sidebar groups by group label, in module order. */
  nav?: { group: string; items: NavItem[] }[]
  routes: RouteDef[]
}

/** Sidebar group order per area (groups not listed go at the end). */
export const NAV_GROUP_ORDER: Record<Area, string[]> = {
  admin: ['Overview', 'Work', 'Money', 'Tools', 'Team', 'Admin'],
  portal: ['Overview', 'My sites'],
  subcon: ['Overview', 'Air testing'],
}
